import React, { useEffect } from "react";
import { ChequeCultureLegacy } from "../components/legacyforms/ChequeCultureLegacy";
import { ChequeCultureService } from "../service/ChequeCultureService";

export const EaLegacyAccueil = () => {
  const chequeCultureService = new ChequeCultureService();

  useEffect(() => {

    chequeCultureService.redirectLoginEaLegacy();
  });

  return (
    <div className="grid">
      <ChequeCultureLegacy />
    </div>
  );
};
